import React, { useEffect, useState } from "react";
import DataTables from "../../CommonDataTable/DataTable";
import config from "../../../../config/config";
import apiCalls from "../../../../config/apiCalls";
import ViewModal from "../../CommonModals/viewModal";
import NewUserModal from "../../CommonModals/NewUserModal";
import showToasterMessage from "../../../UI/ToasterMessage/toasterMessage";
import FormModal from "../../../Form/FormModal";
import store from "../../../App/store";
import filePath from "../../../../config/configSampleFiles";
import fetchMethodRequest from "../../../../config/service";
import RolePermissions from "../../CommonModals/Permissions";
import { useParams } from "react-router";
// config file

/**
 * !PLEASE DO NOT REMOVE THE BELOW FIELDS
 * !THESE FIELDS WILL BE REPLACED IN THE BACKEND AS PER REQUIREMENT
 * @StorageUnits
 * @Storage Units
 * @storageUnits
 * @[{"textAlign":"center","width":47,"field":"Check Box","label":"Check Box","fieldType":"multiple","header":"","selectionMode":"multiple","show":true,"mobile":true,"displayInSettings":true},{"textAlign":"center","width":47,"field":"Sno","label":"SNo","header":"SNo","filter":false,"sortable":false,"placeholder":"Search","show":true,"mobile":true,"displayInSettings":true},{"name":"storageUnitName","type":"text","placeholder":"Storage Unit Name","label":"Storage Unit Name","width":"130px","addFormOrder":7,"editFormOrder":7,"header":"Storage Unit Name","derivedValue":"storageUnitName=storageUnitName=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":true,"actions":[],"actionsNumber":[],"id":"storageUnitName","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"storageUnitName","showOrHideFields":[],"mobile":true,"displayInSettings":true,"fieldType":"Link","style":{"color":"#0e4768","cursor":"pointer","textTransform":"capitalize"}},{"name":"supplyCabinetName","type":"text","placeholder":"Supply Cabinet Name","label":"Supply Cabinet Name","width":"130px","addFormOrder":14,"editFormOrder":14,"header":"Supply Cabinet Name","derivedValue":"supplyCabinetName=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"supplyCabinetName","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"textAlign":"Center","show":false,"field":"supplyCabinetName","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"orSuiteName","type":"text","placeholder":"OR Suite Name","label":"OR Suite Name","width":"130px","addFormOrder":15,"editFormOrder":15,"header":"OR Suite Name","derivedValue":"orSuiteName=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"orSuiteName","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"textAlign":"Center","show":false,"field":"orSuiteName","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"surgeryType","type":"text","placeholder":"Surgery Type","label":"Surgery Type","width":"130px","addFormOrder":16,"editFormOrder":16,"header":"Surgery Type","derivedValue":"surgeryType=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"surgeryType","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"textAlign":"Center","show":false,"field":"surgeryType","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"building","type":"text","placeholder":"Building","label":"Building","width":"130px","addFormOrder":8,"editFormOrder":8,"header":"Building","derivedValue":"building=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"building","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":false,"field":"building","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"area","type":"text","placeholder":"Area","label":"Area","width":"130px","addFormOrder":9,"editFormOrder":9,"header":"Area","derivedValue":"area=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"area","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"textAlign":"Center","show":false,"field":"area","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"floor","type":"text","placeholder":"Floor","label":"Floor","width":"130px","addFormOrder":10,"editFormOrder":10,"header":"Floor","derivedValue":"floor=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"floor","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"textAlign":"Center","show":false,"field":"floor","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"room","type":"text","placeholder":"Room","label":"Room","width":"130px","addFormOrder":11,"editFormOrder":11,"header":"Room","derivedValue":"room=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"room","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"textAlign":"Center","show":false,"field":"room","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"weeklyNotifiedOn","type":"dropDown","placeholder":"Select Day","label":"Weekly Notified On","width":"130px","addFormOrder":12,"editFormOrder":12,"header":"Weekly Notified On","derivedValue":"weeklyNotifiedOn=weeklyNotifiedOn=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"weeklyNotifiedOn","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"options":[{"label":"Sunday","value":"Sunday","color":"primary"},{"label":"Monday","value":"Monday","color":"primary"},{"label":"Tuesday","value":"Tuesday","color":"primary"},{"label":"Wednesday","value":"Wednesday","color":"primary"},{"label":"Thursday","value":"Thursday","color":"primary"},{"label":"Friday","value":"Friday","color":"primary"},{"label":"Saturday","value":"Saturday","color":"primary"}],"fieldType":"dropDown","dependent":[],"textAlign":"Center","show":false,"field":"weeklyNotifiedOn","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"NoOfDrawers","type":"text","placeholder":"Enter No.of Drawers","label":"How many drawers you want to choose?","width":"130px","addFormOrder":14,"editFormOrder":14,"header":"How many drawers you want to choose?","derivedValue":"NoOfDrawers=NoOfDrawers=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"NoOfDrawers","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"textAlign":"Center","show":false,"field":"NoOfDrawers","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"options","type":"relateAutoComplete","placeholder":"Options","label":"Options","width":"150px","addFormOrder":18,"editFormOrder":18,"header":"Options","derivedValue":"options=options=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"options","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":1016,"searchField":"name","fieldType":"relateAutoComplete","displayFields":[],"controllerName":"Min Inventory By State","searchApi":"min inventory by states","textAlign":"Center","show":false,"field":"options","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"createdByName","type":"Text","placeholder":"Created By","label":"Created By","width":120,"header":"Created By","id":"createdByName","displayinlist":"true","globalSearchField":"false","controllerId":1001,"fieldType":"Text","textAlign":"Center","show":true,"field":"createdByName","mobile":true,"filter":true,"displayInSettings":true},{"name":"updatedByName","type":"Text","placeholder":"Updated By","label":"Updated By","width":120,"header":"Updated By","id":"updatedByName","displayinlist":"true","fieldType":"Text","textAlign":"Center","show":true,"filter":true,"field":"updatedByName","mobile":true,"displayInSettings":true},{"name":"created","type":"date","placeholder":"Created","label":"Created","width":90,"header":"Created","derivedValue":"created=undefined","actions":[],"actionsNumber":[],"id":"created","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","textAlign":"Center","disabled":true,"show":true,"field":"created","mobile":true,"displayInSettings":true},{"name":"updated","type":"date","placeholder":"Updated","label":"Updated","width":90,"header":"Updated","derivedValue":"updated=undefined","actions":[],"actionsNumber":[],"id":"updated","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","textAlign":"Center","disabled":true,"show":true,"field":"updated","mobile":true,"displayInSettings":true},{"show":true,"textAlign":"center","width":60,"fieldType":"Actions","field":"Actions","header":"Actions","label":"Actions","filter":false,"sortable":false,"displayInSettings":true,"displayinServer":"false","displayinlist":"true","displayinaddForm":"false","displayineditForm":"false","mobile":true},{"show":true,"textAlign":"center","width":60,"fieldType":"Actions","field":"Actions","header":"Actions","label":"Actions","filter":false,"sortable":false,"displayInSettings":true,"displayinServer":"false","displayinlist":"true","displayinaddForm":"false","displayineditForm":"false","mobile":true}]
 * @[{"name":"storageUnitName","type":"text","placeholder":"Storage Unit Name","label":"Storage Unit Name","width":"130px","addFormOrder":7,"editFormOrder":7,"derivedValue":"storageUnitName=storageUnitName=undefined","capitalizeTableText":true,"sortable":true,"isClickable":false,"filter":true,"actions":[],"actionsNumber":[],"id":"storageUnitName","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"fieldType":"Link","style":{"color":"#0e4768","cursor":"pointer","textTransform":"capitalize"},"isAddFormHidden":false,"isEditFormHidden":false},{"name":"supplyCabinetName","type":"text","placeholder":"Supply Cabinet Name","label":"Supply Cabinet Name","width":"130px","addFormOrder":14,"editFormOrder":14,"derivedValue":"supplyCabinetName=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"supplyCabinetName","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"orSuiteName","type":"text","placeholder":"OR Suite Name","label":"OR Suite Name","width":"130px","addFormOrder":15,"editFormOrder":15,"derivedValue":"orSuiteName=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"orSuiteName","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"surgeryType","type":"text","placeholder":"Surgery Type","label":"Surgery Type","width":"130px","addFormOrder":16,"editFormOrder":16,"derivedValue":"surgeryType=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"surgeryType","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"building","type":"text","placeholder":"Building","label":"Building","width":"130px","addFormOrder":8,"editFormOrder":8,"derivedValue":"building=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"building","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"area","type":"text","placeholder":"Area","label":"Area","width":"130px","addFormOrder":9,"editFormOrder":9,"derivedValue":"area=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"area","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"floor","type":"text","placeholder":"Floor","label":"Floor","width":"130px","addFormOrder":10,"editFormOrder":10,"derivedValue":"floor=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"floor","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"room","type":"text","placeholder":"Room","label":"Room","width":"130px","addFormOrder":11,"editFormOrder":11,"derivedValue":"room=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"room","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"weeklyNotifiedOn","type":"dropDown","placeholder":"Select Day","label":"Weekly Notified On","width":"130px","addFormOrder":12,"editFormOrder":12,"derivedValue":"weeklyNotifiedOn=weeklyNotifiedOn=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"weeklyNotifiedOn","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"options":[{"label":"Sunday","value":"Sunday","color":"primary"},{"label":"Monday","value":"Monday","color":"primary"},{"label":"Tuesday","value":"Tuesday","color":"primary"},{"label":"Wednesday","value":"Wednesday","color":"primary"},{"label":"Thursday","value":"Thursday","color":"primary"},{"label":"Friday","value":"Friday","color":"primary"},{"label":"Saturday","value":"Saturday","color":"primary"}],"fieldType":"dropDown","dependent":[],"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"NoOfDrawers","type":"text","placeholder":"Enter No.of Drawers","label":"How many drawers you want to choose?","width":"130px","addFormOrder":14,"editFormOrder":14,"derivedValue":"NoOfDrawers=NoOfDrawers=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"NoOfDrawers","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"options","type":"relateAutoComplete","placeholder":"Options","label":"Options","width":"150px","addFormOrder":18,"editFormOrder":18,"derivedValue":"options=options=undefined","capitalizeTableText":false,"sortable":false,"isClickable":false,"filter":false,"actions":[],"actionsNumber":[],"id":"options","displayinaddForm":"true","displayineditForm":"true","displayinlist":"false","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":1016,"searchField":"name","fieldType":"relateAutoComplete","displayFields":[],"controllerName":"Min Inventory By State","searchApi":"min inventory by states","show":true,"showOrHideFields":[],"mobile":true,"displayInSettings":true,"isAddFormHidden":false,"isEditFormHidden":false},{"name":"created","type":"date","placeholder":"Created","label":"Created","width":90,"derivedValue":"created=undefined","actions":[],"actionsNumber":[],"id":"created","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","disabled":true,"show":true,"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true},{"name":"updated","type":"date","placeholder":"Updated","label":"Updated","width":90,"derivedValue":"updated=undefined","actions":[],"actionsNumber":[],"id":"updated","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"fieldType":"Date","dateFormat":"YYYY-MM-DD HH:mm:ss","disabled":true,"show":true,"mobile":true,"displayInSettings":true,"isAddFormHidden":true,"isEditFormHidden":true}]
 * @
 * @
 * @
 *
 *
 *
 */

const StorageUnits = (props) => {
  const [languageData, setLanguageData] = useState();
  const [rolePermission, setRolePermission] = useState();
  const [loginRoleType, setLoginRole] = useState('');
  const [editSelectedRecord, setEditSelectedRecord] = useState(
    window.location.href.includes("edit")
  );
  const [addSelectedRecord, setAddSelectedRecord] = useState(
    window.location.href.includes("create")
  );
  const [viewSelectedRecord, setViewSelectedRecord] = useState(
    window.location.href.includes("view")
  );
  const [isOpenFormModal, setIsOpenFormModal] = useState(false);
  const [openNewUserModal, setopenNewUserModal] = useState(false);
  const [item, setItem] = useState({});
  const [newFormFields, setNewFormField] = useState([]);
  const [invStates, setInvStates] = useState(undefined);
  let loginData = JSON.parse(localStorage.getItem('loginCredentials'));

  const [tabType, settabType] = useState("Cart Location");

  const query = new URLSearchParams(location.search);
  const companyId = query.get('comapnyId');
  const companyName = query.get('companyName')
  const params = useParams();

    //state Options
  const handleStateNames = async (e) => {
    // this.setState({
    //   selectedInventoryType: "recommended"
    // })
    let filterCriteria = { sortfield: "name", direction: "desc" }
    let loggedUser = JSON.parse(localStorage.getItem('loginCredentials'));
    let companyId = loggedUser._id
    filterCriteria.criteria = [{ key: "companyId", value: companyId, type: "eq" }]
    return fetchMethodRequest("GET", `minInventoryByStates`).then(
      async (response) => {
        let invStates = [];
        if (response && response.minInventoryByStatesResp) {
          for (let state of response.minInventoryByStatesResp) {
            invStates.push({
              label: state.minInventoryByStateName,
              value: state.minInventoryByStateName,
              state: state
            });
          }
        }
         setInvStates(invStates);
      }
    );
  }
  useEffect(() => {
    getLoginRole();
    let screenPermissions = RolePermissions.screenPermissions("Storage Units");
    if (screenPermissions) {
      setRolePermission(screenPermissions);
    }
    // getTableFields('Cart Location')
    handleStateNames();
  }, []);

  // Get Role Type
  const getLoginRole = async () => {
    let loginData = localStorage.getItem('loginCredentials');
    if (loginData) {
      loginData = JSON.parse(loginData);
      if (loginData && loginData.role) {
        await setLoginRole(loginData.role);
      }
    }
  }




  //state Options
  const getDerivedStateFromProps = (props, state) => {
    let storeData = store.getState();
    let languageData =
      storeData &&
        storeData.settingsData &&
        storeData.settingsData.settings &&
        storeData.settingsData.settings.languageTranslation
        ? storeData.settingsData.settings.languageTranslation
        : "";
    return { languageData: languageData };
  };

  const setData = (props) => {
    let rowData = {};
    if (params.id) {
      rowData["_id"] = JSON.parse(params.id);
      return rowData;
    }
  };

  const submit = async (item) => {
    setIsOpenFormModal(true);
    // await this.formModalRef.getRowData(item, 'edit');
  };
  const closeFormModal = async () => {
    setIsOpenFormModal(false);
  };


  const cancelReset = async (type) => {
    setopenNewUserModal(false);
    window.location.reload();

  };

  const saveDataToServer = async (item, field, value) => {
    let body = item[0];
    body[field] = value;
    let userBody = Object.assign({}, body);
    if (body) {
      let method, apiUrl;
      method = "PUT";
      apiUrl = `${apiCalls["storageUnits"]}/${body._id}`;
      return fetchMethodRequest(method, apiUrl, userBody)
        .then(async (response) => {
          if (response && response.respCode) {
            showToasterMessage(response.respMessage, "success");
          } else if (response && response.errorMessage) {
            showToasterMessage(response.errorMessage, "error");
          }
        })
        .catch((err) => {
          return err;
        });
    } else {
      return;
    }
  };


  const getTableFields = (type) => {
    if (type) {
      settabType(type);

    }
    let data = [];
    if (type) {
      data = getCartLocationTableFields();
    }
    return [...data];
  };

  let getCartLocationTableFields = () => {
    let data = [

      {
        textAlign: "center",
        width: "47px",
        field: "Sno",
        label: "SNo",
        header: "S.No",
        filter: false,
        sortable: false,
        placeholder: "Search",
        show: true,
        mobile: true,
        displayInSettings: true,
      },

      {
        name: "storageUnitName",
        type: "text",
        placeholder: "Storage Unit Name",
        label: "Storage Unit Name",
        width: "300px",
        addFormOrder: 7,
        editFormOrder: 7,
        header: "Storage Unit Name",
        derivedValue: "storageUnitName=storageUnitName=undefined",
        capitalizeTableText: true,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "storageUnitName",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "left",
        show: true,
        field: "storageUnitName",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        // fieldType: "Link",
        fieldType: "getRedirect",
        style: {
          color: "#3475aa",
          cursor: "pointer",
          textTransform: "capitalize",
        },
      },
      {
        name: "facilityName",
        type: "text",
        placeholder: "Facility Name",
        label: "facilityName",
        width: "240px",
        addFormOrder: 7,
        editFormOrder: 7,
        header: "facility Name",
        derivedValue: "facilityName=facilityName=undefined",
        capitalizeTableText: true,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "facilityName",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "true",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        textAlign: "left",
        show: true,
        field: "facilityName",
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        // // fieldType: "Link",

      },

      {
        show: true,
        textAlign: "center",
        width: 120,
        fieldType: "Actions",
        field: "Actions",
        header: "Actions",
        label: "Actions",
        filter: false,
        sortable: false,
        displayInSettings: true,
        displayinServer: "false",
        displayinlist: "true",
        displayinaddForm: "false",
        displayineditForm: "false",
        mobile: true,
      },

    ];
    return data;
  }

  let getFormFields = () => {
    let fields = [];
    if (tabType == 'Supply Cabinets') {
      fields = getCabinetFormFields();
    } else if (tabType == 'OR Suites') {
      fields = getOperatingRoomFormFields();
    } else {
      fields = getCartLocationFormFields();
    }
    return fields;
  }

  let getCabinetFormFields = () => {
    let options = [
      { label: 'Required', value: 'required' },
      { label: 'Recommended', value: 'recommended' },

    ]
    return ([
      {
        name: "facilityName",
        type: "relateAutoComplete",
        placeholder: "Facility Name",
        label: "Facility",
        width: "150px",
        addFormOrder: 1,
        editFormOrder: 1,
        derivedValue: "facilityName=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "facilityName",
        displayinaddForm: "true",
        displayineditForm: "true",
        customCriteria: loginData.role === "Super Admin" ? [{ key: 'companyId', value: companyId, type: 'eq' }] : [],
        displayinlist: "true",
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: 1017,
        searchField: "facilityName",
        fieldType: "relateAutoComplete",
        populteFields: [],
        displayFields: [],
        controllerName: "facilityName",
        searchApi: "facilities",
        isMultiple: false,
        isFieldRequired: "false",
        required: false,
        show: true,
        showOrHideFields: [],
        fieldName: "category",
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "storageUnitName",
        type: "text",
        placeholder: "Supply Cabinet Name",
        label: "Supply Cabinet Name",
        width: "130px",
        addFormOrder: 2,
        editFormOrder: 2,
        derivedValue: "storageUnitName=storageUnitName=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: true,
        actions: [],
        actionsNumber: [],
        id: "storageUnitName",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        isFieldRequired: "false",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        fieldType: "Link",
        style: {
          color: "#0e4768",
          cursor: "pointer",
          textTransform: "capitalize",
        },
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "storageUnitCheckDay",
        type: "dropDown",
        placeholder: "Select Day",
        label: "Weekly Notified On",
        width: "130px",
        addFormOrder: 12,
        editFormOrder: 12,
        derivedValue: "storageUnitCheckDay=storageUnitCheckDay=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "storageUnitCheckDay",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        isFieldRequired: "false",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        options: [
          { label: "Sunday", value: "Sunday", color: "primary" },
          { label: "Monday", value: "Monday", color: "primary" },
          { label: "Tuesday", value: "Tuesday", color: "primary" },
          { label: "Wednesday", value: "Wednesday", color: "primary" },
          { label: "Thursday", value: "Thursday", color: "primary" },
          { label: "Friday", value: "Friday", color: "primary" },
          { label: "Saturday", value: "Saturday", color: "primary" },
        ],
        fieldType: "dropDown",
        dependent: [],
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "noOfCarts",
        type: "text",
        placeholder: "Enter No.of Drawers",
        label: "How many carts you want to create?",
        width: "130px",
        addFormOrder: 14,
        editFormOrder: 14,
        derivedValue: "noOfCarts=noOfCarts=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "noOfCarts",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        isFieldRequired: "false",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
        isEditFieldDisable: true,
        disabled: true,
      },
      {
        name: "minInventoryByStateName",
        type: "dropDown",
        placeholder: "Options",
        label: "Options",
        width: "130px",
        addFormOrder: 20,
        editFormOrder: 20,
        derivedValue:
          "minInventoryByStateName=minInventoryByStateName=storageUnitName=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "minInventoryByStateName",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        showIcon: true,
        // returnType:'Object',
        options: invStates,
        fieldType: "dropDown",
        dependent: [],
        // returnType:'Object',
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
        isAddFieldDisable: false,
        isEditFieldDisable: true,
        disabled: true,
      },
      {
        name: "sublocation",
        type: "dropDown",
        placeholder: "Select Option",
        label: "Sub Location",
        width: "130px",
        addFormOrder: 20,
        editFormOrder: 20,
        // derivedValue:
        //   "minInventoryByStateName=minInventoryByStateName=storageUnitName=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "sublocation",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        // returnType:'Object',
        // required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        // options:opt
        fieldType: "dropDown",
        dependent: [],
        // returnType:'Object',
        show: false,
        showOrHideFields: [],
        mobile: true,
        disabled: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
        isAddFieldDisable: false,
        isEditFieldDisable: true,
      },

    ]);
  }

  let getOperatingRoomFormFields = () => {
    let options = [
      { label: 'Required', value: 'required' },
      { label: 'Recommended', value: 'recommended' },

    ]
    return ([
      {
        name: "facilityName",
        type: "relateAutoComplete",
        placeholder: "facility Name",
        label: "Facility",
        width: "150px",
        addFormOrder: 1,
        editFormOrder: 1,
        derivedValue: "facilityName=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "facilityName",
        customCriteria: loginData.role === "Super Admin" ? [{ key: 'companyId', value: companyId, type: 'eq' }] : [],
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: 1017,
        searchField: "facilityName",
        fieldType: "relateAutoComplete",
        populteFields: [],
        displayFields: [],
        controllerName: "facilityName",
        searchApi: "facilities",
        isMultiple: false,
        isFieldRequired: "false",
        required: false,
        show: true,
        showOrHideFields: [],
        fieldName: "category",
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "storageUnitName",
        type: "text",
        placeholder: "Storage Unit Name",
        label: "Storage Unit Name",
        width: "130px",
        addFormOrder: 2,
        editFormOrder: 2,
        derivedValue: "storageUnitName=storageUnitName=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "storageUnitName",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        isFieldRequired: "false",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        fieldType: "Link",
        style: {
          color: "#0e4768",
          cursor: "pointer",
          textTransform: "capitalize",

        },
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "surgeryType",
        type: "text",
        placeholder: "Surgery Type",
        label: "Surgery Type",
        width: "130px",
        addFormOrder: 16,
        editFormOrder: 16,
        derivedValue: "surgeryType=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "surgeryType",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        isFieldRequired: "false",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "storageUnitCheckDay",
        type: "dropDown",
        placeholder: "Select Day",
        label: "Weekly Notified On",
        width: "130px",
        addFormOrder: 12,
        editFormOrder: 12,
        derivedValue: "storageUnitCheckDay=storageUnitCheckDay=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "storageUnitCheckDay",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        isFieldRequired: "false",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        options: [
          { label: "Sunday", value: "Sunday", color: "primary" },
          { label: "Monday", value: "Monday", color: "primary" },
          { label: "Tuesday", value: "Tuesday", color: "primary" },
          { label: "Wednesday", value: "Wednesday", color: "primary" },
          { label: "Thursday", value: "Thursday", color: "primary" },
          { label: "Friday", value: "Friday", color: "primary" },
          { label: "Saturday", value: "Saturday", color: "primary" },
        ],
        fieldType: "dropDown",
        dependent: [],
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "noOfCarts",
        type: "text",
        placeholder: "Enter No.of Drawers",
        label: "How many carts you want to create?",
        width: "130px",
        addFormOrder: 14,
        editFormOrder: 14,
        derivedValue: "noOfCarts=noOfCarts=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "noOfCarts",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        isFieldRequired: "false",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
        isEditFieldDisable: true,
        disabled: true,
      },
      {
        name: "sublocation",
        type: "dropDown",
        placeholder: "Select Option",
        label: "Sub Location",
        width: "130px",
        addFormOrder: 20,
        editFormOrder: 20,
        // derivedValue:
        //   "minInventoryByStateName=minInventoryByStateName=storageUnitName=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "sublocation",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        // returnType:'Object',
        // required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        // options:opt
        fieldType: "dropDown",
        dependent: [],
        // returnType:'Object',
        show: false,
        showOrHideFields: [],
        mobile: true,
        disabled: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
        isAddFieldDisable: false,
        isEditFieldDisable: true,
        disabled: true,
        // isEditFieldDisable: true,
      },

    ]);
  }
  let getCartLocationFormFields = () => {
    let options = [
      { label: 'Required', value: 'required' },
      { label: 'Recommended', value: 'recommended' },

    ]
    return ([
      {
        name: "facilityName",
        type: "relateAutoComplete",
        placeholder: "Search Facility Name",
        label: "Facility",
        width: "150px",
        addFormOrder: 1,
        editFormOrder: 1,
        derivedValue: "facilityName=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "facilityName",
        customCriteria: loginData.role === "Super Admin" ? [{ key: 'companyId', value: companyId, type: 'eq' }] : [],
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        required: false,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: 1017,
        searchField: "facilityName",
        fieldType: "relateAutoComplete",
        populteFields: [],
        displayFields: [],
        controllerName: "facilityName",
        searchApi: "facilities",
        isMultiple: false,
        show: true,
        showOrHideFields: [],
        fieldName: "category",
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "storageUnitName",
        type: "text",
        placeholder: "Cart Name",
        label: "Cart Name",
        width: "130px",
        addFormOrder: 7,
        editFormOrder: 7,
        derivedValue: "storageUnitName=storageUnitName=undefined",
        capitalizeTableText: true,
        sortable: true,
        isClickable: false,
        filter: true,
        actions: [],
        actionsNumber: [],
        id: "storageUnitName",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        fieldType: "Link",
        style: {
          color: "#0e4768",
          cursor: "pointer",
          textTransform: "capitalize",
        },
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "storageUnitCheckDay",
        type: "dropDown",
        placeholder: "Select Day",
        label: "Weekly Notified On",
        width: "130px",
        addFormOrder: 12,
        editFormOrder: 12,
        derivedValue: "storageUnitCheckDay=storageUnitCheckDay=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "storageUnitCheckDay",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        isFieldRequired: "false",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        options: [
          { label: "Sunday", value: "Sunday", color: "primary" },
          { label: "Monday", value: "Monday", color: "primary" },
          { label: "Tuesday", value: "Tuesday", color: "primary" },
          { label: "Wednesday", value: "Wednesday", color: "primary" },
          { label: "Thursday", value: "Thursday", color: "primary" },
          { label: "Friday", value: "Friday", color: "primary" },
          { label: "Saturday", value: "Saturday", color: "primary" },
        ],
        fieldType: "dropDown",
        dependent: [],
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
      },
      {
        name: "noOfCarts",
        type: "text",
        placeholder: "Enter No.of Drawers",
        label: "How many carts you want to create?",
        width: "130px",
        addFormOrder: 14,
        editFormOrder: 14,
        derivedValue: "noOfCarts=noOfCarts=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "noOfCarts",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        isFieldRequired: "false",
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
        isEditFieldDisable: true,
        disabled: true,
      },
      {
        name: "minInventoryByStateName",
        type: "dropDown",
        placeholder: "Select Option",
        label: "Options",
        width: "130px",
        addFormOrder: 20,
        editFormOrder: 20,
        derivedValue:
          "minInventoryByStateName=minInventoryByStateName=storageUnitName=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "minInventoryByStateName",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        // returnType:'Object',
        required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        options: invStates,
        fieldType: "dropDown",
        dependent: [],
        // returnType:'Object',
        show: true,
        showOrHideFields: [],
        mobile: true,
        disabled: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
        isAddFieldDisable: false,
        isEditFieldDisable: true,
      },
      {
        name: "barCode",
        type: "text",
        label: "Barcode Number",
        width: "130px",
        addFormOrder: 14,
        editFormOrder: 14,
        derivedValue: "noOfCarts=noOfCarts=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "barCode",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "false",
        isFieldRequired: "false",
        required: false ,
        displayOptionsInActions: false,
        globalSearchField: "false",
        controllerId: null,
        show: true,
        showOrHideFields: [],
        mobile: true,
        displayInSettings: true,
        isAddFormHidden: false,
      },
      {
        name: "sublocation",
        type: "dropDown",
        placeholder: "Select Option",
        label: "Sub Location",
        width: "130px",
        addFormOrder: 20,
        editFormOrder: 20,
        // derivedValue:
        //   "minInventoryByStateName=minInventoryByStateName=storageUnitName=undefined",
        capitalizeTableText: false,
        sortable: false,
        isClickable: false,
        filter: false,
        actions: [],
        actionsNumber: [],
        id: "sublocation",
        displayinaddForm: "true",
        displayineditForm: "true",
        displayinlist: "true",
        isFieldRequired: "false",
        // returnType:'Object',
        // required: true,
        displayOptionsInActions: false,
        globalSearchField: "true",
        controllerId: null,
        // options:opt
        fieldType: "dropDown",
        dependent: [],
        // returnType:'Object',
        show: false,
        showOrHideFields: [],
        mobile: true,
        disabled: true,
        displayInSettings: true,
        isAddFormHidden: false,
        isEditFormHidden: false,
        isAddFieldDisable: false,
        // isEditFieldDisable: true,
      },

    ]);
  }




  return (
    <span>
      {
        // invStates &&
        loginRoleType &&
        <DataTables
          {...props}
          getTableFields={getTableFields}
          formFields={getFormFields}
          //
          addRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          editRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          deleteRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          viewRequired={
            rolePermission && rolePermission == "Edit" ? true : false
          }
          // globalSearch={'Display Name/Email'}
          // type='Storage Units'
          // apiUrl={apiCalls.Storage Units}
          // exportRequried={true}
          printRequried={false}
          actionsTypes={false}
          settingsRequired={false}
          filterRequired={false}
          gridRequried={false}
          exportToCsv={false}
          dateSearchRequired={false}
          searchInDateRangeField={""}
          setData={setData}
          selectionMode={true}
          getPagination={true}
          editSelectedRecord={editSelectedRecord}
          addSelectedRecord={addSelectedRecord}
          viewSelectedRecord={viewSelectedRecord}
          sampleFilePath={filePath["storageUnits"]}
          globalSearch={false}
          modalHeaderName="Cart Location"
          type="Storage Units"
          routeTo={apiCalls["storageUnits"]}
          displayViewOfForm="screen"
          sideFormLeftOrRight=""
          apiResponseKey={apiCalls["storageUnits"].toLowerCase()}
          apiUrl={apiCalls["storageUnits"]}
          selectedId={params.id}
          tabType={tabType}
          redirectTo={'inventoryCheckLists'}
          loginRoleType={loginRoleType}
          companyId={companyId}
          companyName={companyName}
        />
      }
      {isOpenFormModal ? (
        <FormModal
          // onRef={(ref) => (this.formModalRef = ref)}
          formType="edit"
          openFormModal={isOpenFormModal}
          formFields={formFields}
        />
      ) : null}
      {openNewUserModal ? (
        <NewUserModal
          openNewUserModal={openNewUserModal}
          cancelReset={cancelReset}
          item={item}
          newFormFields={newFormFields}
          recordId={item._id}
          entityType="storageUnits"
          apiUrl={apiCalls["storageUnits"]}
        />
      ) : null}
    </span>
  );
};

export default StorageUnits;
